// extracted by mini-css-extract-plugin
export default {"name":"style_name__ytdK-","svg_container":"style_svg_container__fo1Ey","active":"style_active__2Gpd5"};